import auditLogsModule from "./audit-logs";

const userManagementsModule = {
  namespaced: true,
  modules: {
    "audit-logs": auditLogsModule,
  },
};

export default userManagementsModule;
